import { Link } from "@tanstack/react-router";

export function SiteFooter() {
  return (
    <footer className="text-brew-sm font-medium text-brew-muted" />
  )
}
